import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PageStatus } from '../models/page-status';

@Injectable()
export class StatusPageService {

  constructor(private http: HttpClient) {

  }

  public GetPageStatus(url: string): Observable<PageStatus> {
    return this.http.get<PageStatus>(url)
      .pipe(
        catchError((err, caught) => {
          console.error('logging err:', err);
          console.error('logging caught:', caught);
          return of(err);
        }),
        (data) => {
          return data;
        }
      );
  }
}
